module.exports = __webpack_public_path__ + "static/logo-abbvie-b5b7fd1fc138c2e450e1a4ad4a6d4425.png";